<div class="row banner task-amend">
    <div class="col">
        <h6 class="pt-5px"><strong>Configure activities
            </strong></h6>
    </div>
    <div class="col">
        <button (click)="createActivity()" class="btn btn-secondary float-end">
            Create new activity
        </button>
    </div>
</div>

<form [formGroup]="activityFilter" class="search">

<div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
        <ng-select (change)="setWIT()" [items]="employeeCategories" formControlName="employeeCategory" bindLabel="displayText"
            [placeholder]="'Employee category'">
        </ng-select>
    </div>
    <div class="m-0 me-3 w-35">
        <ng-select [items]="pbTypes" formControlName="pbType" bindLabel="displayText"
            [placeholder]="'Preboarding type'">
        </ng-select>
    </div>
    <div class="m-0 me-3 w-35">
        <ng-select [items]="countries" formControlName="country" bindLabel="displayText" [placeholder]="'Countries'">
        </ng-select>
    </div>
    <div class="m-0 me-3 w-35 d-flex flex-row">
        <button (click)="clearForm()" style="height:29px" eosDebounce class="btn btn-primary ms-2">Clear</button>

        <button (click)="onSubmit()" style="height:29px" eosDebounce [disabled]="!activityFilter.valid"
            class="btn btn-primary ms-2" type="submit">Search</button>
    </div>
</div>
<div *ngIf="showControl" class="row ms-1 mt-3">
    <input formControlName="isWSO" type="checkbox" class="check-input mt-1">
    <label class="ms-1">
        Is Transfer type within the same office?
    </label>
</div>
    
</form>


<div class="d-flex table-resp candid-table mt-3" *ngIf="activities.length">

    <table class="table table-bordered table-hover">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Activity</th>
                <th scope="col">Type</th>
                <th scope="col" class="text-center">Active</th>
                <th scope="col" class="text-end">Order</th>
                <th scope="col" class="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let act of activities; index as i">
                <td>{{ i + 1 }}</td>
                <td>

                    {{ act.header }}
                </td>
                <td>
                    {{act.activityTypeString }}
                </td>
                <td class="text-center">
                    <div class="d-flex justify-content-center">
                        <div class="activity-icon activity-{{act.isActive}}"></div>
                    </div>
                </td>
                <td class="text-end">{{ act.order }}</td>
                <td class="text-center">
                    <img class="cursor-pointer" title="Edit activity" *ngIf="act.activityType === 101"
                        (click)="editActivity(act)" src="design/images/edit.png" />
                    <img class="cursor-pointer" title="Clone activity" *ngIf="act.activityType === 101"
                        (click)="cloneActivity(act)" src="design/images/copy.png" />
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="card mt-3 text-center d-flex p-5" *ngIf="!activities.length">
    <div class="card-body">
        No activities found for the given filter values
    </div>
</div>